'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.useService = void 0;
var tslib_1 = require('tslib');
var typed_redux_saga_1 = require('typed-redux-saga');
var useSaga_1 = require('./useSaga');
function useService(service, args) {
    var onLoad = function () {
        var _i;
        var args = [];
        for (_i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0, tslib_1.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [
                        5 /*yield**/,
                        (0, tslib_1.__values)(
                            typed_redux_saga_1.call.apply(
                                void 0,
                                (0, tslib_1.__spreadArray)([service.run], (0, tslib_1.__read)(args), false)
                            )
                        ),
                    ];
                case 1:
                    return [2 /*return*/, _a.sent()];
            }
        });
    };
    var onDispose = function () {
        var _i;
        var args = [];
        for (_i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0, tslib_1.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [
                        5 /*yield**/,
                        (0, tslib_1.__values)(
                            typed_redux_saga_1.call.apply(
                                void 0,
                                (0, tslib_1.__spreadArray)([service.destroy], (0, tslib_1.__read)(args), false)
                            )
                        ),
                    ];
                case 1:
                    return [2 /*return*/, _a.sent()];
            }
        });
    };
    return (0, useSaga_1.useSaga)({ onLoad: onLoad, onDispose: onDispose }, args || []);
}
exports.useService = useService;
